module.exports = __webpack_public_path__ + "0ddc174a06c5ca182409f42b26ef61e3.pdf";